import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { of, Subject } from 'rxjs';
import { debounceTime, filter, switchMap, tap } from 'rxjs/operators';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { CustomComponent, IBakery } from '@cakeiteasy/web-utils';

import { MODAL_CLOSE_ACTIONS } from '@shared/constants/common.constants';
import { BakeriesApiService } from '@cakeiteasy/order-process';
import { LocationManagerService } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  templateUrl: './how-it-works-modal.component.html',
  styleUrls: ['./how-it-works-modal.component.scss']
})
export class HowItWorksModalComponent extends CustomComponent implements OnInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;

  public placeName: string;
  public countryCode: string;
  public bakeries: IBakery[];
  public fieldChange$ = new Subject<string>();
  public busy: Promise<any>;
  public nothingFound: boolean = false;

  constructor(public modal: NgbActiveModal,
              private _bakeriesService: BakeriesApiService,
              private _locationManager: LocationManagerService,
              private _scrollService: ScrollToService) {
    super();

    this._subscribe();
  }

  ngOnInit(): void {
    this.countryCode = this._locationManager.getDomainName();
  }

  public contactUs() {
    this.modal.close(MODAL_CLOSE_ACTIONS.OPEN_CONTACT_US);
  }

  private _subscribe() {
    this.addSubscriber(this.fieldChange$
      .pipe(
        filter((query) => query && query.length >= 2),
        tap(() => this.nothingFound = false),
        debounceTime(350),
        switchMap((placeName) => {
          if (placeName) {
            return this.busy = this._bakeriesService.getBakeriesByPlaceName(this.countryCode, placeName).catch(() => []);
          } else {
            return of([]);
          }
        }))
      .subscribe((bakeries) => {
        this.bakeries = bakeries;
        this.bakeries.forEach((b) => b.cities.sort());
        this.nothingFound = !bakeries.length;
        setTimeout(() => this._scrollService.scrollTo({ target: this.scrollContainer }));
      }));
  }
}
